var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousMoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#B6C5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0035 65.3711C48.6226 65.9215 49.5707 65.8657 50.1211 65.2465C50.6715 64.6274 50.6157 63.6793 49.9965 63.1289L48.0035 65.3711ZM24.25 42.25L23.2201 41.1595C22.9143 41.4483 22.7438 41.8521 22.7502 42.2726C22.7565 42.6932 22.9391 43.0917 23.2535 43.3711L24.25 42.25ZM50.0299 19.9655C50.6322 19.3967 50.6593 18.4473 50.0905 17.8451C49.5217 17.2428 48.5723 17.2157 47.9701 17.7845L50.0299 19.9655ZM49.9965 63.1289L25.2465 41.1289L23.2535 43.3711L48.0035 65.3711L49.9965 63.1289ZM25.2799 43.3405L50.0299 19.9655L47.9701 17.7845L23.2201 41.1595L25.2799 43.3405Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousMoveIcon);
export default __webpack_public_path__ + "static/media/PreviousMoveIcon.c7ef17535bc7ede37f25ae4a5818489b.svg";
export { ForwardRef as ReactComponent };